import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { Form } from '../../../components/Form/styles'

export const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 246px);
  width: 100%;

  @media (max-width: 900px) {
    grid-auto-flow: row;
  }
`

export const LogoContainer = styled.div`
  max-height: calc(100vh - 246px);
  padding: 2rem 1rem 2rem 2rem;
  width: 55%;

  @media (max-width: 900px) {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  ${({ backgroundImage }) => css`
    background-image: url(${backgroundImage});
    background-position-x: clamp(-95px, 35%, 0px);
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: calc(var(--border-radius-lg) + 1px);
    min-height: 100%;
    min-width: 100%;
    position: relative;

    > img {
      bottom: 2rem;
      left: 2rem;
      position: absolute;
    }

    @media (max-width: 900px) {
      display: none;
    }
  `}
`

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 4rem 2rem 3rem;
  width: 45%;

  > ${Form} {
    margin: 0;
  }

  @media (max-width: 900px) {
    width: 100%;
    align-items: center;
    padding: 2rem;
    min-height: calc(100vh - 246px);
  }
`

export const FlexEndContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`

export const ForgotPassword = styled(Link)`
  color: var(--text-tertiary);
  font-size: var(--font-size-sm);
  text-decoration: none;

  transition: color 0.2s ease-in-out;
  width: max-content;
  &:hover {
    color: var(--text-dark);
  }
`
